<template>
	<label class="b-toggle" :class="classes">
		<input type="checkbox" :disabled="disabled" v-model="innerModel" />
		<template v-if="$slots.default">
			<slot />
		</template>
		<template v-else>
			{{ label }}
		</template>
	</label>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: null,
		},
		label: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "m",
			validator: (value) => ["s", "m"].includes(value),
		},
	},
	data() {
		return {};
	},
	computed: {
		classes() {
			return [`b-toggle--${this.size}`];
		},
		innerModel: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>

<style lang="scss">
.b-toggle {
	display: inline-flex;
	text-align: center;
	align-items: center;
	justify-content: center;
	border: 1px solid transparent;
	border-radius: 50px;
	cursor: pointer;

	input {
		display: none;
	}

	&--s {
		padding: 6px 12px;
		height: 32px;
		font-size: var(--font-size-xs);
	}

	&--m {
		padding: 8px 16px;
		height: 44px;
		font-size: var(--font-size-m);
	}

	&:has(:not(input:checked)) {
		color: var(--color-primary-600);
		border-color: var(--color-primary-600);

		&:has(:not(:disabled)) {
			&:is(:hover, :focus) {
				--color-border: var(--color-primary-700);
				color: var(--color-primary-700);
				border-color: var(--color-border);
				box-shadow: inset 0 0 0 1px var(--color-border);
			}

			&:active {
				--color-border: var(--color-primary-800);
				color: var(--color-primary-800);
				border-color: var(--color-border);
				box-shadow: inset 0 0 0 1px var(--color-border);
			}
		}

		&:has(:disabled) {
			color: var(--color-neutral-175);
			border-color: var(--color-neutral-175);
			cursor: not-allowed;
		}
	}

	&:has(input:checked) {
		color: #fff;
		background-color: var(--color-primary-600);

		&:has(:not(:disabled)) {
			&:is(:hover, :focus) {
				background-color: var(--color-primary-700);
			}

			&:active {
				background-color: var(--color-primary-800);
			}
		}

		&:has(:disabled) {
			background-color: var(--color-neutral-175);
			cursor: not-allowed;
		}
	}
}
</style>
